import React, { useState, useEffect } from 'react';
import api from '../api/axios';
import Swal from 'sweetalert2';
import { FaCalendarAlt, FaHashtag, FaFilePdf } from 'react-icons/fa';

export default function MyTickets() {
    const [tickets, setTickets] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchMyTickets = async () => {
            try {
                const response = await api.get('/my-tickets');

                let userTickets = response.data?.data || response.data?.tickets || response.data || [];

                // تأمين إضافي زي اللي عملناه في الرئيسية
                if (!Array.isArray(userTickets)) {
                    console.error("API did not return an array. It returned:", userTickets);
                    userTickets = [];
                }

                setTickets(userTickets);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching tickets:", error);
                Swal.fire('Error', 'Unable to load your tickets.', 'error');
                setLoading(false);
            }
        };
        fetchMyTickets();
    }, []);

    const handleDownload = async (ticketId) => {
        try {
            Swal.fire({
                title: 'Generating PDF...',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading()
            });

            const response = await api.get(`/tickets/${ticketId}/download`, {
                responseType: 'blob',
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `TicketFlow-Ticket-${ticketId}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();

            Swal.close();
        } catch (error) {
            console.error(error);
            Swal.fire('Error', 'Failed to download the ticket.', 'error');
        }
    };

    if (loading) {
        return <div className="mt-5 text-center"><h4 className="text-muted">Loading your tickets... ⏳</h4></div>;
    }

    return (
        <div className="container mt-5">
            <div className="text-center mb-5 fade-in-up">
                <h2 className="fw-bold text-dark">My Tickets 🎫</h2>
                <p className="text-muted">Manage and download your confirmed event tickets.</p>
            </div>

            <div className="row justify-content-center">
                {/* السحر هنا: تأكيد إن tickets مصفوفة */}
                {Array.isArray(tickets) && tickets.length > 0 ? (
                    tickets.map((ticket, index) => (
                        <div
                            className="col-md-6 mb-4 fade-in-up"
                            key={ticket.id}
                            style={{ animationDelay: `${index * 0.15}s` }}
                        >
                            <div className="card event-card h-100 border-0" style={{ borderLeft: '6px solid #28a745' }}>
                                <div className="card-body p-4">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <h5 className="card-title text-dark fw-bold mb-0">
                                            {ticket.event?.title || 'Unknown Event'}
                                        </h5>
                                        <span className="badge bg-success rounded-pill px-3 py-2">Confirmed</span>
                                    </div>

                                    <div className="card-text text-secondary mb-4 mt-3">
                                        <div className="d-flex align-items-center mb-2">
                                            <FaCalendarAlt className="text-primary me-3" />
                                            <span>{ticket.event ? new Date(ticket.event.event_date).toLocaleDateString('en-US', { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric' }) : 'N/A'}</span>
                                        </div>
                                        <div className="d-flex align-items-center mb-2">
                                            <FaHashtag className="text-info me-3" />
                                            <span>Ticket ID: #{ticket.id}</span>
                                        </div>
                                    </div>

                                    <hr className="text-muted opacity-25" />

                                    <button
                                        className="btn btn-outline-success w-100 rounded-pill fw-bold d-flex align-items-center justify-content-center"
                                        onClick={() => handleDownload(ticket.id)}
                                    >
                                        <FaFilePdf className="me-2" /> Download PDF Ticket
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="col-12 text-center fade-in-up">
                        <div className="alert alert-light shadow-sm d-inline-block rounded-pill px-4">
                            You don't have any confirmed tickets yet. Go to the Home page to book one!
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}